import React from 'react'
import PropTypes from 'prop-types'
import { Box, Chip, Tooltip, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { formatUtcDate } from '@/utils/date'
import { DRIVE_DONORS_DATE_FORMAT } from './constants'

export const EligibilityBadge = ({
  eligibility,
  showProcedureTooltip = false,
}) => {
  if (!eligibility) {
    return <Typography variant='body2'>N/A</Typography>
  }

  const {
    status,
    eligible_procedures = [],
    next_eligibility_date,
  } = eligibility

  if (status === 'eligible') {
    const content = (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Chip
          size='small'
          color='success'
          icon={<CheckIcon />}
          label='Eligible for this drive'
          sx={{ width: 'fit-content' }}
        />
      </Box>
    )

    if (showProcedureTooltip && eligible_procedures.length > 0) {
      return (
        <Tooltip title={`Eligible for: ${eligible_procedures.join(', ')}`}>
          <Box>{content}</Box>
        </Tooltip>
      )
    }

    return content
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Chip
        size='small'
        color='default'
        variant='outlined'
        icon={<CloseIcon />}
        label='Not eligible for this drive'
        sx={{ width: 'fit-content' }}
      />
      {next_eligibility_date ? (
        <Typography variant='caption' color='text.secondary'>
          Eligible on{' '}
          {formatUtcDate(next_eligibility_date, DRIVE_DONORS_DATE_FORMAT)}
        </Typography>
      ) : null}
    </Box>
  )
}

EligibilityBadge.propTypes = {
  eligibility: PropTypes.object,
  showProcedureTooltip: PropTypes.bool,
}
